// State shared between legacy modules.
export const state = {
    // Last video player in the viewport (Videos); the menu pauses it when it opens.
    videoInView: null,
};
